import {Component, OnInit, AfterViewChecked, Injectable, Input} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {AppConfig} from "../../app.config";
import {HttpService} from "../../services/http.service";

@Component({
    selector: 'app-right-panel',
    templateUrl: './right-panel.component.html'
})

export class RightPanelComponent implements OnInit, AfterViewChecked {
    @Input() public lastComments: any = [];
    public categories = [];
    public lastBlogs = [];
    public AppConfig = AppConfig;
    public fragment: any;

    constructor(public router: Router, private activatedRoute: ActivatedRoute, public http: HttpService) {

    }

    ngOnInit() {
        this.getCategories();
        // this.getLastBlogs();
        this.activatedRoute.fragment.subscribe(fragment => {
            this.fragment = fragment;
        });
    }

    ngAfterViewChecked(): void {
        try {
            if (this.fragment) {
                document.querySelector('#' + this.fragment).scrollIntoView();
            }
        } catch (e) {
        }
    }

    getCategories() {
        this.http.get(AppConfig.baseUrlApi + 'categories/api_categories').subscribe(response => {
            this.categories = response.content;
        }, error => {
            console.log(error);
        });
    }

    getCategoryLink(category) {
        return '/blog/category/' + category.category.replace(' ', '-') + '-' + category.id_category;
    }

    // getLastBlogs() {
    //     this.http.get(AppConfig.baseUrlApi + 'articles/api_articles').subscribe(response => {
    //         this.lastBlogs = response.content.articles.slice(-2);
    //     }, error => {
    //         console.log(error);
    //     });
    // }

    keywordsSearch(value) {
        this.router.navigate(['/blog/search', value]);
    }
}



// WEBPACK FOOTER //
// /home3/usalinks/public_html/ally-book-source/src/app/blog/right-panel/right-panel.component.ts